//
//
//
//
//
//
//
//
//
//
//
//
//
var isCancelable = function isCancelable(status) {
  return ['delete failed', 'paused', 'queued', 'retrying upload', 'submitted', 'uploading', 'upload failed'].indexOf(status) >= 0;
};

export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    onlyRenderIfCancelable: {
      type: Boolean,
      "default": true
    },
    uploader: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      state: {
        cancelable: true
      },
      _unmounted: false
    };
  },
  mounted: function mounted() {
    this.uploader.on('statusChange', this._onStatusChange);
  },
  beforeDestroy: function beforeDestroy() {
    this._unmounted = true;

    this._unregisterStatusChangeHandler();
  },
  methods: {
    _onStatusChange: function _onStatusChange(id, oldStatus, newStatus) {
      if (id === this.id && !this._unmounted) {
        if (!isCancelable(newStatus) && this.state.cancelable) {
          this.$set(this.state, 'cancelable', false);
        } else if (isCancelable(newStatus) && !this.state.cancelable) {
          this.$set(this.state, 'cancelable', true);
        } else if (newStatus === 'deleted' || newStatus === 'canceled') {
          this._unregisterStatusChangeHandler();
        }
      }
    },
    _onClick: function _onClick() {
      if (this.state.cancelable) {
        this.uploader.methods.cancel(this.id);
      }
    },
    _unregisterStatusChangeHandler: function _unregisterStatusChangeHandler() {
      this.uploader.off('statusChange', this._onStatusChange);
    }
  }
};